class RecCaptchaGame extends HTMLElement {
    constructor() {
        super();
        this.gameStatus = this.getAttribute('data-status');
        this.userSelections = new Set(); 
        this.boundBeginGame = () => this.beginGame();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-status') {
            this.gameStatus = newValue; 
        }
    }

    connectedCallback() {
        // Setup //
        this.gatewayButton = this.querySelector('.recaptcha-game__gateway-prompt');
        this.verifyButton = this.querySelector('.recaptcha-game__verify');
        this.restartGame = this.querySelector('.recaptcha-game__prompt-failed button');
        const sequenceAttr = this.getAttribute('data-sequence') || '';
        this.winningSequence = sequenceAttr.split(',').map(num => parseInt(num.trim(), 10));
        this.recaptcha_tiles = this.querySelectorAll('.recaptcha-game__tile');

        // Events //
        this.gatewayButton.addEventListener('click', this.boundBeginGame);
        this.recaptcha_tiles.forEach(tile => {
            tile.addEventListener('click', () => this.handleTileClick(tile));
        });
        this.verifyButton.addEventListener('click', () => this.checkResults() );
        this.restartGame.addEventListener('click', () => this.resetGame() );
    }

    // Timeout added for recptcha check effect, not required for restart //
    beginGame(skipTimeout = false) {
        this.gatewayButton.removeEventListener('click', this.boundBeginGame);
        this.gatewayButton.setAttribute('data-click', 'active');
        
        if (skipTimeout) {
            this.setAttribute('data-status', 'active');
        } else {
            setTimeout(() => {
                this.setAttribute('data-status', 'active');
            }, 200);
        }
    }

    // Handle tile sections //
    handleTileClick(tile) {
        const index = parseInt(tile.getAttribute('data-index'), 10);

        // Allow toggle of click if active //
        if (this.userSelections.has(index)) {
            this.userSelections.delete(index);
            tile.setAttribute('data-toggle', 'inactive');
            return;
        }

        // Manage active state & selection array //
        this.userSelections.add(index);
        tile.setAttribute('data-toggle', 'active');
    }

    checkResults() {
        // Winner determined by how many clicks registered compared to how many in winning sequence & which squares //
        const isWinner = this.winningSequence.length === this.userSelections.size && 
                    this.winningSequence.every(num => this.userSelections.has(num));

        if (isWinner) {
            document.querySelector('.recaptcha-game').setAttribute('data-winner', true);
            document.querySelector('.recaptcha-game--success').setAttribute('data-winner', true);
        } 
        else {
            this.setAttribute('data-status', 'inactive');
            this.gatewayButton.removeAttribute('data-click');
            this.gatewayButton.setAttribute('data-reset', 'true');
        }
    }

    resetGame() {
        this.userSelections.clear();
        this.recaptcha_tiles.forEach(tile => tile.setAttribute('data-toggle', 'inactive'));
        this.beginGame(true);
    }
}

if (!customElements.get('recaptcha-game')) {
  customElements.define('recaptcha-game', RecCaptchaGame);
}